module.exports = __webpack_public_path__ + "img/metal_w@2x.8a7e2f75.png";